import { httpRequest } from "@services/http";
import { SegmentPopulation } from "@models/population.model";

/** Column filters on the roster (MPN-1613). Omitted keys leave that column alone. */
export type RosterFilters = {
  /** Consumer column: matches a name, or the id, which is the label shown for a
   *  consumer whose person record carries no name. */
  consumerQ?: string;
  /** Steps Taken column: CONVERSION | PRECONVERT | REVERSION. */
  traceType?: string;
  /** Steps Taken column: one journey step. */
  journeyStepId?: number;
  /** Steps Taken column: one file date. */
  asOf?: string;
};

export class CommandGetSegmentPopulation {
  async run(
    populationSegmentId: number,
    limit = 50,
    offset = 0,
    controlMode: string | null = null,
    testMode: string | null = null,
    filters: RosterFilters = {},
  ): Promise<SegmentPopulation> {
    const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
    if (controlMode) params.set("control_mode", controlMode);
    if (testMode) params.set("test_mode", testMode);
    // Only send what is set. An empty string would reach the server as a filter and
    // narrow the roster to nothing.
    if (filters.consumerQ?.trim()) params.set("consumer_q", filters.consumerQ.trim());
    if (filters.traceType) params.set("trace_type", filters.traceType);
    if (filters.journeyStepId) params.set("journey_step_id", String(filters.journeyStepId));
    if (filters.asOf) params.set("as_of", filters.asOf);
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/populations/${populationSegmentId}/?${params}`;
    return httpRequest<SegmentPopulation>(url, { method: "GET", cache: "no-store" });
  }
}
